// https://asiga.atlassian.net/wiki/spaces/UiUX/pages/90112055/Colour+Theme
// Confluence page last updated: 11 September 2024

import { alpha } from "@mui/material/styles";

export interface ColorThemeOptions {
  text: {
    onSurface: string;
    onSurfaceVariant: string;
  };

  primary: {
    primary: string;
    onPrimary: string;
  };

  secondary: {
    secondary: string;
    onSecondary: string;
  };

  status: {
    // Error/Destructive
    error: string;
    onError: string;
    errorContainer: string;
    amber: string;
    amberContainer: string;
    green: string;
    greenFill: string;
    asigaBlue: string;
    asigaBlueContainer: string;
    focus: string;
  };

  other: {
    inverseSurface: string;
    inverseOnSurface: string;
    outlineVariant: string;
  };

  surfaces: {
    surfaceContainerLowest: string;
    surfaceContainerLow: string;
    surfaceContainer: string;
    surfaceContainerHigh: string;
    surfaceContainerHighest: string;
  };

  //   TODO effects (shadow and progress bar)
}

export const colorTheme = {
  text: {
    onSurface: "#202324",
    onSurfaceVariant: alpha("#202324", 0.6)
  },

  primary: {
    primary: "#202324",
    onPrimary: "#FFFFFF"
  },

  secondary: {
    secondary: "#ECECEC",
    onSecondary: "#202324"
  },

  status: {
    // Error/Destructive
    error: "#FD4A46",
    onError: "#FFFFFF",

    errorContainer: alpha("#FD4A46", 0.08),
    amber: "#FFB800",
    amberContainer: alpha("#FFB800", 0.08),
    green: "#30D158",
    greenFill: alpha("#30D158", 0.08),
    asigaBlue: "#00AEEF",
    asigaBlueContainer: alpha("#00AEEF", 0.08),
    focus: alpha("#F316B0", 0.4)
  },

  other: {
    inverseSurface: "#202324",
    inverseOnSurface: "#FFFFFF",
    outlineVariant: "#C1C7CE"
  },

  surfaces: {
    surfaceContainerLowest: "#FFFFFF",
    surfaceContainerLow: "#FAFAFA",
    surfaceContainer: "#F5F5F5",
    surfaceContainerHigh: "#DEDEDE",
    surfaceContainerHighest: "#C2C2C2"
  }
} as ColorThemeOptions;
